import { format } from 'date-fns';
import { StyleSheet, View } from 'react-native';

import { IconTime, Text, tokens } from '@fhs/ui';
import { PICKUP_TIME_SELECTOR_NEXT_DAY_WARNING } from '@fhs-legacy/frontend/src/utils/test-ids';

interface INextDayWarningProps {
  shouldShowNextDayWarning: boolean;
  firstAvailableDate: Date | undefined;
}

export default function NextDayWarning({
  shouldShowNextDayWarning,
  firstAvailableDate,
}: INextDayWarningProps) {
  if (!shouldShowNextDayWarning || !firstAvailableDate) {
    return null;
  }

  const formattedTime = format(new Date(firstAvailableDate), 'h:mm a');

  return (
    <View testID={PICKUP_TIME_SELECTOR_NEXT_DAY_WARNING} style={styles.container}>
      <View style={styles.iconContainer}>
        <IconTime size={20} />
      </View>
      <View style={styles.content}>
        <Text.Ui size="md" weight="semibold" style={styles.title}>
          This Store Is Closing
        </Text.Ui>
        <Text.Ui size="md" style={styles.message}>
          Next pickup: Tomorrow at {formattedTime}
        </Text.Ui>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    borderWidth: 1,
    backgroundColor: '#FFEDD5',
    borderColor: '#D7A748',
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 16,
    marginHorizontal: 16,
    marginBottom: 16,
  },
  iconContainer: {
    width: 32,
    height: 32,
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    flex: 1,
    marginLeft: 12,
    justifyContent: 'center',
  },
  title: {
    marginBottom: 2,
  },
  message: {
    color: tokens.colors.$black,
  },
});
